import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

interface Props {
  // Use it to render as a small spinner
  small?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'InlineSpinner',
  props: {
    small: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  // Use it to render as a small spinner
  small?: boolean;
};

// ========== PROPS ==========


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["spinner-border", { 'spinner-border-sm': props.small }]),
    role: "status"
  }, null, 2))
}
}

})